// profile pages
import OvervVew from "../Pages/Profile/OvervVew";
import UserProfile from "../Pages/Profile/UserProfile";
import SalaryDetails from "../Pages/Profile/SalaryDetails";
import Documents from "../Pages/Profile/Documents";
import Letters from "../Pages/Profile/Letters";
import MyLeaves from "../Pages/Profile/MyLeaves";
import OverTime from "../Pages/Profile/OverTime";
import MyAttendance from "../Pages/Profile/MyAttendance";
import MyAttendanceReport from "../Pages/Profile/MyAttendanceReport";
import MyRegularization from "../Pages/Profile/MyRegularization";
import PaySlip from "../Pages/Profile/PaySlip";

// Approer pages
import TeamLeaves from "../Pages/Team/TeamLeaves";
import TeamRegularization from "../Pages/Team/TeamRegularization";
import TeamAttendanceReport from "../Pages/Team/TeamAttendanceReport";
import MyLeavesSandBox from "../Pages/SandBox/Profile/MyLeavesSandBox";
import TeamLeavesBalance from "../Pages/Team/TeamLeavesBalance";
import TeamsLeavesSandBox from "../Pages/SandBox/Team/TeamsLeavesSandBox";
import TeamsAttendanceReport from "../Pages/SandBox/Team/TeamsAttendanceReport";
import TeamEmployees from "../Pages/Team/TeamEmployees";
import PaySlipSandbox from "../Pages/Profile/PaySlipSandBox";
import OfferLetter from "../Pages/GuestProfile/OfferLetter";
import Page404 from "../Layout/Page404";
import CreatePmsTask from "../Pages/Team/CreatePmsTask";
import AssignGoals from "../Pages/Team/AssignGoals";
import EmployeePMS from "../Pages/Profile/EmployeePMS";
import GoalReview from "../Pages/Team/GoalReview";
import Resignation from "../Pages/Profile/Resignation";
import TeamResignation from "../Pages/Team/TeamResignation";
import MyExpense from "../Pages/Profile/MyExpense";
import TeamExpense from "../Pages/Team/TeamExpense";
import UserProfileDetails from "../Pages/UserProfileDetails/UserProfileDetails";
import MyPolicy from "../Pages/Profile/MyPolicy";
import HelpAndSupport from "../Pages/HelpAndSupport/HelpAndSupport";





// routes.js
const routes = [
  ////////////////////// Profile Routing ///////////////////////////
  // { path: '/', element: <OvervVew /> },
  // { path: '/', element: <UserProfile /> },
  { path: '/', element: <UserProfileDetails /> },
  { path: '/SalaryDetails', element: <SalaryDetails /> },
  { path: '/Letters', element: <Letters /> },
  { path: '/Documents', element: <Documents /> },
  { path: '/MyLeaves', element: <MyLeaves /> },
  { path: '/MyLeavesSandBox', element: <MyLeavesSandBox /> },
  // { path: '/OverTime', element: <OverTime /> },
  { path: '/MyGoals', element: <EmployeePMS /> },
  { path: '/MyExpense', element: <MyExpense /> },
  { path: '/MyAttendance', element: <MyAttendance /> },
  { path: '/MyAttendanceReport', element: <MyAttendanceReport /> },
  { path: '/MyRegularization', element: <MyRegularization /> },
  { path: '/MyPayslip', element: <PaySlip /> },
  { path: '/PaySlipSandBox', element: <PaySlipSandbox /> },
  { path: '/MyResignation', element: <Resignation /> },
  { path: '/MyPolicy', element: <MyPolicy /> },
  
  ////////////////////////// Guest Employee ///////////////////////////
  { path: '/offer-letter', element: <OfferLetter /> },
  { path: '/404', element: <Page404 />},

  ////////////////////// Approver Routing ///////////////////////////
  { path: '/GoalsMaster', element: <CreatePmsTask /> },
  { path: '/AssignGoals', element: <AssignGoals /> },
  { path: '/GoalReview', element: <GoalReview /> },
  { path: '/TeamLeaves', element: <TeamLeaves /> },
  { path: '/TeamEmployees', element:  <TeamEmployees /> },
  { path: '/TeamsLeavesSandBox', element: <TeamsLeavesSandBox/> },
  { path: '/TeamLeavesBalance', element: <TeamLeavesBalance /> },
  { path: '/TeamRegularization', element: <TeamRegularization /> },
  { path: '/TeamAttendanceReport', element: <TeamAttendanceReport /> },
  { path: '/TeamsAttendanceReportSandBox', element: <TeamsAttendanceReport /> },
  { path: '/TeamsResignation', element: <TeamResignation /> },
  { path: '/TeamExpense', element: <TeamExpense /> },
  { path: '/HelpAndSupport', element: <HelpAndSupport /> },
];

export default routes;